import React, { useState } from 'react';
import { Popover } from '@mantine/core';

import { showToast } from 'utils/utility';
import { useHotelData } from 'libs/data-access';
import { IHotelOnlineBookingList } from 'libs/data-access/types';
import { EButton, ECheckbox, EPopover, ETextInput } from 'libs/ui';

interface IProps {
    hotelTicket: IHotelOnlineBookingList;
    handleRefresh: () => void;
};

export default function ResolveTicket({ ...props }: IProps) {

    const {
        postHotelData
    } = useHotelData();

    const [resolveTicketState, setResolveTicketState] = useState<{
        opened: boolean;
        referenceNo: string;
        confirmed: boolean;
        isSaving: boolean;
    }>({
        opened: false,
        referenceNo: "",
        confirmed: false,
        isSaving: false
    });


    // HADNLER FUNCTIONS
    const closePopover = () => setResolveTicketState({
        opened: false,
        referenceNo: "",
        confirmed: false,
        isSaving: false
    });


    // API CALLS
    const resolveTicket = async () => {

        if (!props.hotelTicket?.id) {
            showToast({
                time: 5 * 1000,
                type: "warning",
                message: "Please select a booking and provide the ticket information first!"
            });
            return;
        };

        if (!resolveTicketState.referenceNo) {
            showToast({
                type: "warning",
                message: "Please fill the ticket information!"
            });
            return;
        };

        // console.log("resolveTicketState: ", resolveTicketState);

        // setResolveTicketState({ ...resolveTicketState, isSaving: true });

        const response = await postHotelData(`/booking/${props.hotelTicket.id}/pnr-details?bookingId=${props.hotelTicket.id}&referenceNo=${resolveTicketState.referenceNo}`, null);

        if (response.isSuccess) {
            console.log("Response for resolving ticket: ", response);
            showToast({
                type: "success",
                message: "Ticket resolved successfully!"
            });
            closePopover();
            props.handleRefresh();
        } else {
            console.log("Error while resolving ticket: ", response);
            showToast({
                type: "error",
                message: response.message || "Error while resolving ticket!"
            });
        };

        setResolveTicketState({ ...resolveTicketState, isSaving: false });

    };


    return (
        <EPopover
            width={450}
            opened={resolveTicketState.opened}
            onClose={closePopover}
        >
            <Popover.Target>
                <div>
                    <EButton
                        size="sm"
                        variant="light"
                        color="green"
                        disabled={props.hotelTicket?.bookingStatus !== "FAILED"}
                        onClick={() => setResolveTicketState({ ...resolveTicketState, opened: !resolveTicketState.opened })}
                    >Resolve</EButton>
                </div>
            </Popover.Target>

            <Popover.Dropdown>
                <div className="flex flex-col gap-6">
                    {
                        props.hotelTicket
                            ?
                            <>
                                <ETextInput
                                    label="Reference No."
                                    placeholder="Enter reference no."
                                    value={resolveTicketState.referenceNo ?? undefined}
                                    onChange={(e) => setResolveTicketState({ ...resolveTicketState, referenceNo: e.target.value })}
                                />

                                <ECheckbox
                                    // indeterminate
                                    label="Are you sure you want to resolve this ticket?"
                                    checked={resolveTicketState.confirmed}
                                    onChange={(e) => setResolveTicketState({ ...resolveTicketState, confirmed: e.target.checked })}
                                />

                                {
                                    resolveTicketState.confirmed
                                        ?
                                        <div className="flex justify-end gap-2">
                                            <EButton
                                                variant="light"
                                                onClick={closePopover}
                                            >Cancel</EButton>
                                            <EButton
                                                onClick={resolveTicket}
                                            >Save</EButton>
                                        </div>
                                        :
                                        <></>
                                }
                            </>
                            :
                            <></>
                    }
                </div>
            </Popover.Dropdown>
        </EPopover>
    )
}